export const ContainerStyle = {
  height: "500px",
};

export const DefaultCenter = {
  lat: -3.745,
  lng: -38.523,
};
